import { render, staticRenderFns } from "./Beymen.vue?vue&type=template&id=6b7882b0&scoped=true"
import script from "./Beymen.vue?vue&type=script&lang=js"
export * from "./Beymen.vue?vue&type=script&lang=js"
import style0 from "./Beymen.vue?vue&type=style&index=0&id=6b7882b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7882b0",
  null
  
)

export default component.exports